export default {"src":"/_next/static/image/public/images/flags/flag_503.d5f8af1b22acc2bf2654ff57eeb5cff7.svg","height":16,"width":25};